import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { profile } from '../data/profile';
import { sections } from '../data/sections';
export function TopNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-navy-950/95 backdrop-blur" data-id="element-111" data-mp="1fatjxrxs7rxt">
      <nav aria-label="Section navigation" className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-6 px-6 lg:px-10" data-id="element-112" data-mp="1ab8gp5bkwxfa">
        <Link to="/" className="shrink-0 font-display text-sm font-bold uppercase tracking-[0.2em] text-white transition-colors duration-150 ease-out hover:text-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-400" data-id="element-113" data-mp="11ashi81vccg8">
          {profile.name}
        </Link>

        <ul className="hidden items-center gap-6 xl:flex" data-id="element-114" data-mp="3j1vh4yen1lqw">
          {sections.map(section => <li key={section.path} data-id="element-115" data-mp="3nydn21lpfq4t">
              <NavLink to={section.path} end={section.path === '/'} className={({
            isActive
          }) => `whitespace-nowrap font-sans text-[13px] font-medium transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-400 ${isActive ? 'text-gold-400' : 'text-platinum-300 hover:text-white'}`} data-id="element-116" data-mp="3nxatflwzz9l7">
                {section.navLabel}
              </NavLink>
            </li>)}
        </ul>

        <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-label={open ? 'Close section menu' : 'Open section menu'} className="inline-flex h-10 items-center gap-2 rounded-sm border border-white/20 px-3 font-sans text-xs font-semibold uppercase tracking-[0.14em] text-white transition-colors duration-150 ease-out hover:border-gold-500 hover:text-gold-400 xl:hidden" data-id="element-117" data-mp="2hb88lssa6w1y">
          {open ? <XIcon className="h-4 w-4" data-id="element-118" data-mp="izolif1lxcp4" /> : <MenuIcon className="h-4 w-4" data-id="element-119" data-mp="e2y5tstpsj48" />}
          Sections
        </button>
      </nav>

      {open ? <div className="max-h-[70vh] overflow-y-auto border-t border-white/10 bg-navy-950 px-6 py-4 xl:hidden" data-id="element-120" data-mp="1atgy99j2sg3h">
          <ul className="mx-auto flex w-full max-w-7xl flex-col gap-px bg-white/10" data-id="element-121" data-mp="16r3tanc5km7r">
            {sections.map(section => <li key={section.path} data-id="element-122" data-mp="11qpjazqzr273">
                <NavLink to={section.path} end={section.path === '/'} className={({
            isActive
          }) => `flex items-baseline gap-4 bg-navy-950 px-3 py-3.5 transition-colors duration-150 ease-out ${isActive ? 'text-gold-400' : 'text-platinum-200 hover:text-white'}`} data-id="element-123" data-mp="wt64nyqdsnem">
                  <span className="font-display text-xs font-bold text-gold-500" data-id="element-124" data-mp="3ce1j7ygwokfh">{section.number}</span>
                  <span className="font-sans text-sm font-medium" data-id="element-125" data-mp="3hd4fatewrgbb">{section.name}</span>
                </NavLink>
              </li>)}
          </ul>
        </div> : null}
    </header>;
}